import { Button, Card, HSpacing, Text, useBreakpoint, VSpacing } from '@hh.ru/magritte-ui';
import { SPALink } from '@hh.ru/redux-spa-middleware';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import urlParser from 'bloko/common/urlParser';

import paths from 'src/app/routePaths';
import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';

import styles from './vacancy-hint.less';

const HintType = {
    Remote: 'remote',
    FlyInFlyOut: 'flyInFlyOut',
} as const;

const TrlKeys = {
    [HintType.Remote]: 'search.vacancy.hint.remote',
    [HintType.FlyInFlyOut]: 'search.vacancy.hint.flyInFlyOut',
    submit: 'search.vacancy.change.region',
};

interface VacancyHintProps {
    hintType: (typeof HintType)[keyof typeof HintType];
}

const VacancyHint: TranslatedComponent<VacancyHintProps> = ({ trls, hintType }) => {
    const currentParams = useSelector((state) => state.vacancySearchResult.queries.currentParams);

    const { isMobile } = useBreakpoint();

    const url = urlParser(paths.vacancySearch);
    url.search = currentParams || '';
    url.params.area = null;

    const button = (
        <Button
            mode="primary"
            style="accent"
            Element={SPALink}
            to={url.href}
            size="small"
            data-qa={`reset-region-${hintType}`}
            stretched={isMobile}
        >
            {trls[TrlKeys.submit]}
        </Button>
    );

    // TODO: заменить на компонент баннера в https://jira.hh.ru/browse/PORTFOLIO-31934
    return (
        <>
            <VSpacing default={12} gteM={24} />
            {isMobile ? (
                <Card style="accent-secondary" padding={12} borderRadius={24} stretched>
                    <Card style="accent-secondary" padding={12}>
                        <Text>{trls[TrlKeys[hintType]]}</Text>
                    </Card>
                    <VSpacing default={12} />
                    {button}
                </Card>
            ) : (
                <Card style="accent-secondary" padding={24} borderRadius={24} stretched>
                    <div className={styles.vacancyHintContent}>
                        <Text>{trls[TrlKeys[hintType]]}</Text>
                        <HSpacing default={16} />
                        {button}
                    </div>
                </Card>
            )}
            <VSpacing default={24} gteM={0} />
        </>
    );
};

export default translation(VacancyHint);
